// components/MetaData.ts
import type { Metadata } from 'next'

export const metadata: Metadata = {
  title: "SupplySense 360",
  // Add other metadata properties as needed
}